//Keys that move the focus around - typing, escape or shortcuts keep the current modality
const focusNavKeys = new Set([
    'Tab', 'Enter', ' ', 'Spacebar',
    'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
    'Home', 'End', 'PageUp', 'PageDown',
]);

const isTextEntry = (target: EventTarget | null) => {
    const el = target as HTMLElement | null;
    if (!el || !el.tagName) return false;
    return el.tagName === 'INPUT'
        || el.tagName === 'TEXTAREA'
        || el.isContentEditable === true;
};

let pointer = false;

const setModality = (isPointer: boolean) => {
    pointer = isPointer;
    document.documentElement.dataset.pointerInput = isPointer ? 'true' : 'false';
};

if (typeof window !== 'undefined') {
    window.addEventListener('pointerdown', () => setModality(true), true);
    window.addEventListener('keydown', (event) => {
        if (!focusNavKeys.has(event.key)) return;
        if (event.key !== 'Tab' && isTextEntry(event.target)) return;
        setModality(false);
    }, true);
}

export const lastInputWasPointer = () => pointer;
